const Label = ({ children }) => (
    <span className="text-[13px] md:text-xs font-semibold uppercase tracking-[0.14em] text-gold-text">{children}</span>
);

const BeforeAfter = ({ c }) => {
    const afterPct = Math.round((c.after / c.before) * 100);
    const saved = c.before - c.after;
    return (
        <div role="img" aria-label={`Frais bancaires annuels : ${c.before} K€ avant, ${c.after} K€ après, soit ${saved} K€ et ${c.pct} % de moins`} className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
                <div className="flex justify-between text-[13px]"><span className="font-semibold">Avant · {c.ratioBefore} du CA</span><span className="font-bold">{c.before} K€</span></div>
                <div className="h-[22px] rounded bg-navy w-full" />
            </div>
            <div className="flex flex-col gap-1.5">
                <div className="flex justify-between text-[13px]"><span className="font-semibold">Après · {c.ratioAfter} du CA</span><span className="font-bold">{c.after} K€</span></div>
                <div className="flex h-[22px] rounded overflow-hidden">
                    <div className="bg-navy-band" style={{ width: `${afterPct}%` }} />
                    <div className="flex-1" style={{ background: "repeating-linear-gradient(135deg, #EFD9A0 0 6px, #FAF3E3 6px 12px)" }} />
                </div>
                <div className="text-[13px] font-semibold text-gold-text text-right">− {saved} K€ soit − {c.pct} %</div>
            </div>
        </div>
    );
};

export const CaseStudyDetail = ({ c }) => (
    <div className="text-navy">
        <div className="p-[22px] md:p-10 flex flex-col gap-4 border-b border-border-soft">
            <Label>Cas client · Optimisation des frais bancaires</Label>
            <h3 data-testid={`case-title-${c.key}`} className="m-0 text-[22px] md:text-[32px] font-bold leading-[1.2] tracking-[-0.02em]">
                <span className="text-gold-text">{c.savings}</span> d'économies par an pour {c.title}, en {c.days} jours
            </h3>
            <div className="flex flex-wrap gap-2">
                {c.tags.map((t) => (
                    <span key={t} className="bg-sand rounded-full px-3.5 py-1.5 text-[13px] font-medium">{t}</span>
                ))}
            </div>
        </div>
        <div className="flex flex-wrap">
            <div className="flex-1 basis-[340px] min-w-0 p-[22px] md:p-10 flex flex-col gap-7 md:border-r border-border-soft">
                <div className="flex flex-col gap-2.5">
                    <Label>Le constat</Label>
                    <p className="m-0 text-[15px] leading-[1.7] text-grey-text">{c.constat}</p>
                </div>
                <div className="flex flex-col gap-3">
                    <Label>L'intervention · {c.days} jours</Label>
                    <ol className="list-none m-0 p-0 flex flex-col gap-2.5">
                        {c.steps.map((s, i) => (
                            <li key={s} className="flex gap-3.5 items-center text-[15px]">
                                <span className="w-8 h-8 rounded-full bg-navy text-cream flex items-center justify-center text-sm font-semibold shrink-0">{i + 1}</span>
                                {s}
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
            <div className="flex-1 basis-[340px] min-w-0 p-[22px] md:p-10 flex flex-col gap-[22px] bg-cream border-t md:border-t-0 border-border-soft">
                <div className="flex flex-col gap-2.5">
                    <Label>Le résultat</Label>
                    <p className="m-0 text-[15px] leading-[1.7] text-grey-text">{c.resultat}</p>
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex items-baseline gap-2.5 flex-wrap">
                        <span className="font-bold text-[40px] md:text-[60px] leading-none tracking-[-0.03em] text-gold-text tabular-nums">−{c.savings}</span>
                        <span className="text-lg font-medium">/ an</span>
                    </div>
                    <span className="text-sm text-grey-text-soft">d'économies récurrentes, dès la première année</span>
                </div>
                <BeforeAfter c={c} />
                <div className="grid grid-cols-3 gap-2.5 border-t border-border-soft pt-[18px]">
                    {[[`−${c.pct} %`, "de frais", true], [c.ratioAfter, "frais / CA"], [`${c.days} j`, "de mission"]].map(([v, l, gold]) => (
                        <div key={l} className="flex flex-col gap-0.5">
                            <span className={`font-bold text-[26px] ${gold ? "text-gold-text" : ""}`}>{v}</span>
                            <span className="text-[11px] font-semibold uppercase tracking-[0.1em] text-grey-text-soft">{l}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);
